import FormControl from '@material-ui/core/FormControl';
import React from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import MuiAlert from '@material-ui/lab/Alert';
import Snackbar from '@material-ui/core/Snackbar';
import { Input, } from "reactstrap";

function Status(props) {
    const [sendingdata, setSendingdata] = React.useState('');
    const [tt, settt] = React.useState('');
    const [open, setOpen] = React.useState(false);

    const state = props.productStat;
    const keyb = props.prodKey;
    const [age, setAge] = React.useState(state);

    const handleClose = (event, reason) => {
        setOpen(false);
    };

    const handleChange = (event) => {
        console.log(event.target.value)
        console.log(keyb)
        setSendingdata('Please wait a sec')
        settt('success')
        setOpen(true);
        var inp = { "status": event.target.value }
        console.log(inp)
        axios.post(process.env.REACT_APP_DOMAIN+'/changestatus/preevent=' + keyb, inp, { 'headers': { 'Authorization': 'Token ' + props.token } })
            .then((response) => {
                console.log(response.data)
                if (response.data.errori === true) {
                    setSendingdata('Something went wrong')
                    settt('error')
                    setOpen(true);
                }
                else {
                    setSendingdata('Status has been changed successfully')
                    settt('success')
                    setOpen(true);
                    setAge(inp.status);
                    props.fetch()
                }

            })
            .catch((error) => {
                setSendingdata('Something went wrong')
                settt('error')
                setOpen(true);
            })
    };
    return (
        <div>
            <FormControl>
                <Input
                    id={age}
                    value={age}
                    key={age}
                    type="select"
                    onChange={handleChange}
                    className={"form-control-alternative min-width-150 inputbg-" + props.theme}
                >
                    <option key="Select Status" value="" disabled >Select Status</option>
                    <option key="Pending" value="Pending">Pending</option>
                    <option key="Ongoing" value="Ongoing">Ongoing</option>
                    <option key="Confirmed" value="Confirmed">Confirmed</option>
                    <option key="Finished" value="Finished">Finished</option>
                    <option key="Cancelled" value="Cancelled">Cancelled</option>
                </Input>
            </FormControl>
            <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }} open={open} autoHideDuration={6000} onClose={handleClose}>
                <MuiAlert elevation={6} variant="filled" onClose={handleClose} severity={tt}>{sendingdata}</MuiAlert>
            </Snackbar>
        </div>
    );
}


export const mapStateToProps = state => {
    // console.log("this is the state", state);
    return {
        adminValue: state.switchRoutes.admin,
        superValue: state.switchRoutes.superadmin,
        userValue: state.switchRoutes.user,
        username: state.userName,
        fullname: state.tempUser,
        theme: state.theme,
        text: state.text,
        token: state.token,
    }
}

export default connect(mapStateToProps)(Status);